import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      "max-width": _ctx.isDesktop() ? "420px" : "calc(100% - 20px)",
      width: "90%",
      popupClass: "b-popup-style--no-shadow",
      allowBackgroundScrolling: true,
      disableClosingOnClickOutside: true,
      popupBackground: "#fff",
      popupRadius: "20px"
    }, {
      body: _withCtx(() => [
        _createVNode(_component_ResetPasswordForm, { onSubmitForm: _ctx.submitResetPasswordForm }, null, 8, ["onSubmitForm"])
      ]),
      _: 1
    }, 8, ["max-width"])
  ]))
}